module.exports = __webpack_public_path__ + "static/media/bg13.395202eb.jpeg";